import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MaintenanceService {
    private maintenanceSubject = new BehaviorSubject<boolean>(false);
    maintenance$ = this.maintenanceSubject.asObservable();

    showMaintenance() {
        this.maintenanceSubject.next(true);
    }

    hideMaintenance() {
        this.maintenanceSubject.next(false);
    }

    isMaintenanceMode(): boolean {
        return this.maintenanceSubject.value;
    }


} 